import { Vector3 } from 'three';
const v3 = new Vector3();
export const isObjectVisible = (objectToTest, camera, raycaster, occlude) => {
    const elPos = v3.setFromMatrixPosition(objectToTest.matrixWorld);
    const screenPos = elPos.clone().project(camera);
    raycaster.setFromCamera(screenPos, camera);
    const intersects = raycaster.intersectObjects(occlude, true);
    if (intersects.length) {
        const intersectionDistance = intersects[0].distance;
        const pointDistance = elPos.distanceTo(raycaster.ray.origin);
        return pointDistance < intersectionDistance;
    }
    else {
        return true;
    }
};
